module.exports = __webpack_public_path__ + "static/media/m-startup-img.5a6be828.png";